import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import Cookies from "js-cookie";
import url from "../../function/url";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
function CompanyInformation() {
    const ID = Cookies.get("log_id");
    const navigate = useNavigate();
    const [Director,setDirector] = useState("");
    const [dirnumber,setDirecnumber] = useState("");
    const [dirmail,setDirmail] = useState("");
    const [gstno,setGstnumber] = useState("");
    const [date,setDate] = useState("");
    const [branch,setBranch] = useState("");
    const [branchaddress,setBranchaddress] = useState("");
    const [branchcontact,setBranchcontact] = useState("");
    const [sinsisnumb,setSinsisnumber] = useState("");
    function  handleSubmit(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('director',Director);
        formdata.append('dircontact',dirnumber);
        formdata.append('diremail',dirmail);
        formdata.append('gstno',gstno);
        formdata.append('date',date);
        formdata.append('branch',branch);
        formdata.append('branchaddress',branchaddress);
        formdata.append('branchcont',branchcontact);
        formdata.append('sinsis',sinsisnumb);
        axios
        .put(`${url.path}/company_reg3/`, formdata)
      .then((res) => {
        if (res.data.status){
          Toast.fire({
            icon: "success",
            title: "Registered successfully",
          });
          navigate("/login");
        }
      })
      .catch((err) => {
        Toast.fire({
          icon:'error',
          title:err
        })
      });
    }
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    function  phonenumbervalidation(val) {
      var phonenumber = val;
      var regPhoneNumber = /^\d{10}$/; 
      if (regPhoneNumber.test(phonenumber)){
        document.getElementById('phno').style.display = 'none'; 
      } else {
        document.getElementById('phno').style.display = 'block'; 
      }
    }
    function  phonenumbervalid(val) {
      var phonenumber = val;
      var regPhoneNumber = /^\d{10}$/; 
      if (regPhoneNumber.test(phonenumber)){
        document.getElementById('brcontact').style.display = 'none'; 
      } else {
        document.getElementById('brcontact').style.display = 'block'; 
      }
    }
    function emailvalidation(val) {
      var mail = val;
      var email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (email.test(mail)) {
        document.getElementById('ema').style.display = 'none';
      } else {
        document.getElementById('ema').style.display = 'block';
      }
    }
    return(
        <>
            <Navbar />
            <div className="employee-details-container">
      <div className="employee-details">
        <div className="form-container">
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-3 gap-4">
              <div className="form-group">
                <label htmlFor="employeeName" className="block text-sm font-medium text-gray-700">
                  Director Name (IF any)
                </label>
                <input
                  type="text"
                  id="employeeName"
                  className="w-full mt-1 p-2 border rounded-md "
                  placeholder="Director Name" value={Director} onChange={(e) =>setDirector(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="employeePosition" className="block text-sm font-medium text-gray-700">
                  Director Contact (IF any)
                </label>
                <input
                  type="text"
                  id="employeePosition"
                  className="w-full mt-1 p-2 border rounded-md "
                  placeholder="Director Contact" value={dirnumber} onChange={(e) =>setDirecnumber(e.target.value)} onInput={(e) =>phonenumbervalidation(e.target.value)}
                />
                 <h5 style={{color:'red',display:'none'}} id="phno">Phone Number is not valid!!!</h5>
              </div>
              <div className="form-group">
                <label htmlFor="employeeEmail" className="block text-sm font-medium text-gray-700">
                Director Email (IF any)
                </label>
                <input
                  type="email"
                  id="employeeEmail"
                  className="w-full mt-1 p-2 border rounded-md "
                  placeholder="Director Email" value={dirmail} onChange={(e) =>setDirmail(e.target.value)} onInput={(e) =>emailvalidation(e.target.value)} 
                />
                <h5 style={{color:'red',display:'none'}} id="ema">Email is not valid!!!</h5>
              </div>
              <div className="form-group">
                <label htmlFor="employeeEmail" className="block text-sm font-medium text-gray-700">
                  GST Number
                </label>
                <input
                  type="text"
                  id="Phone"
                  className="w-full mt-1 p-2 border rounded-md "
              placeholder="GST Number" value={gstno} onChange={(e) =>setGstnumber(e.target.value)}
                />
              </div>
                <div className="form-group">
                <label htmlFor="employeeEmail" className="block text-sm font-medium text-gray-700">
                Date of Establishment
                </label>
                <input
                  type="date"
                  id="employeeEmail"
                  className="w-full mt-1 p-2 border rounded-md "
                  placeholder="Enter department" value={date} onChange={(e) =>setDate(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label className="block text-sm font-medium text-gray-700">Branches (IF any)</label>
               <input type="checkbox" checked={branch} onChange={(e) =>setBranch(e.target.value)}  />
              </div>
              <div className="form-group">
                <label className="block text-sm font-medium text-gray-700">Branch Address</label>
                <input type="text" placeholder="Enter Branch Address" value={branchaddress} onChange={(e) =>setBranchaddress(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="block text-sm font-medium text-gray-700">Branch Contact</label>
                <input type="text" placeholder="Enter Branch Contact" value={branchcontact} onChange={(e) =>setBranchcontact(e.target.value)} onInput={(e) =>phonenumbervalid(e.target.value)} />
                <h5 style={{color:'red',display:'none'}} id="brcontact">Phone Number is not valid!!!</h5>
              </div>
              <div className="form-group">
                <label className="block text-sm font-medium text-gray-700">SIN/SIS Number</label>
                <input type="text" placeholder="SIN/SIS Number" value={sinsisnumb} onChange={(e) =>setSinsisnumber(e.target.value)} />
              </div>
            </div>

            <button type="submit" className="submit-btn">Register</button>
          </form>
        </div>
       
      </div>

    </div>
        </>
    );
}
export default CompanyInformation;
